import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../config/axios';

function ListProductPage() {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [images, setImages] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const previews = useMemo(() => images.map((image) => URL.createObjectURL(image)), [images]);

  const handleProductUpload = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (images.length < 1) {
      setError('Add at least one product photo.');
      return;
    }

    const formData = new FormData();
    formData.append('name', name);
    formData.append('description', description);
    formData.append('price', price);
    formData.append('quantity', quantity);
    images.forEach((image) => formData.append('images', image));

    try {
      setSubmitting(true);
      await axiosInstance.post('/api/products', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setSuccess('Listing published. It is now visible in the marketplace.');
      setName('');
      setDescription('');
      setPrice('');
      setQuantity(1);
      setImages([]);
      setTimeout(() => navigate('/my-products'), 600);
    } catch (err) {
      setError(err.response?.data?.message || 'Could not publish this listing.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleImageChange = (e) => {
    const selectedFiles = [...e.target.files].slice(0, 5);
    if (e.target.files.length > 5) {
      setError('Only the first 5 images were selected.');
    } else {
      setError('');
    }
    setImages(selectedFiles);
  };

  return (
    <div className="page-shell">
      <section className="form-layout">
        <div className="form-intro">
          <span className="eyebrow">Seller center</span>
          <h1>Create a listing that is easy to trust.</h1>
          <p>Add clear photos, a specific title, a fair price, and enough detail for buyers to decide quickly.</p>
        </div>

        <form onSubmit={handleProductUpload} className="panel-form">
          {error && <div className="notice error">{error}</div>}
          {success && <div className="notice success">{success}</div>}

          <label>
            Product Name
            <input
              type="text"
              placeholder="Apple Magic Keyboard, walnut desk, vintage jacket"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label>
            Description
            <textarea
              rows="5"
              placeholder="Condition, included accessories, pickup or shipping details"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            ></textarea>
          </label>
          <div className="form-grid-two">
            <label>
              Price
              <input
                type="number"
                min="0.01"
                step="0.01"
                placeholder="49.99"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                required
              />
            </label>
            <label>
              Quantity
              <input
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(Math.min(200, Math.max(1, Number(e.target.value) || 1)))}
                min="1"
                max="200"
                required
              />
            </label>
          </div>
          <label>
            Product Photos
            <input type="file" accept="image/*" multiple onChange={handleImageChange} required />
            <span className="field-note">Add up to 5 images.</span>
          </label>

          {previews.length > 0 && (
            <div className="preview-grid">
              {previews.map((preview, index) => (
                <img key={preview} src={preview} alt={`Preview ${index + 1}`} />
              ))}
            </div>
          )}

          <button type="submit" className="button button-primary" disabled={submitting}>
            {submitting ? 'Publishing...' : 'Publish Listing'}
          </button>
        </form>
      </section>
    </div>
  );
}

export default ListProductPage;
